import React from 'react';
import { Modal, ModalProps } from 'react-bootstrap';
import { createModal } from 'react-modal-promise';
import { CollectionsGridPage } from './collections-grid-page';

type Props = {
  open: boolean;
  close: (result: any) => void;
  collectionPointId: number;
  collectionpoint: any;
} & ModalProps;

const ModalCollections = ({ open, close, collectionPointId, collectionpoint }: Props) => {
  return (
    <Modal size="xl" show={open} onHide={() => close(null)} centered backdrop="static">
      <Modal.Header closeButton className="app-modal-header">
        <Modal.Title className="app-modal-title">
          {`Συλλογές Αποβλήτων: ${collectionpoint.collectionpoint.name}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="app-modal-body">
        <div className="app-modal-content-card">
          <CollectionsGridPage
            isGridInForm={true}
            isModal={true}
            onClose={close}
            collectionPointId={collectionPointId}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="app-modal-footer">
        <button type="button" className="btn btn-secondary px-4" onClick={() => close(null)}>
          Κλείσιμο
        </button>
      </Modal.Footer>
    </Modal>
  );
};

// Export modal function to trigger it dynamically
export const promiseModalCollectionPointCollections = createModal(ModalCollections);

